import script from "./PanelOverview.vue?vue&type=script&setup=props&lang=js"
export * from "./PanelOverview.vue?vue&type=script&setup=props&lang=js"

import "./PanelOverview.vue?vue&type=style&index=0&id=09839d16&lang=scss&scoped=true"
script.__scopeId = "data-v-09839d16"

export default script